export enum RewardType {
  CPA,
  CPL,
  RevShare,
  CPI,
  BL,
}
